import { useEffect, useState } from 'react'
import axios from 'axios'

interface DexScreenerResponse {
  pairs: {
    priceUsd: string
  }[]
}

const useDexscreener = (tokenAddress: string) => {
  const [tokenPrice, setTokenPrice] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [dexscreenerError, setdexscreenerError] = useState<string | null>(null)

  const fetchTokenPrice = async () => {
    try {
      setLoading(true)
      const response = await axios.get<DexScreenerResponse>(
        `https://api.dexscreener.com/latest/dex/pairs/ethereum/${tokenAddress}`,
      )
      const price = parseFloat(response.data.pairs[0].priceUsd)
      setTokenPrice(price)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching token price:', error)
      setdexscreenerError('Error fetching token price')
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTokenPrice()
  }, [tokenAddress])

  return { tokenPrice, loading, dexscreenerError }
}

export default useDexscreener
